module.exports = __webpack_public_path__ + "img/butter-popcorntime.png";